export var BASE_CALENDAR_STATUS_KEY = 'calendar-status';
var calendarStatusKeys = {
  calendarStatus: [BASE_CALENDAR_STATUS_KEY]
};
export default calendarStatusKeys;